import axios from 'axios'

import { ResponseObjectPaginated } from '../model'
import {
  LaundryBillingModel,
  LaundryCostModel,
} from '../features/laundryBilling/model/laundryBilling.model'
import {
  LaundryFilterReportModel,
  LaundryFilterReportLaundry2Model,
} from '../features/laundryBilling/model/laundryBilling.model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL

// ----------------------  VIEW LAUNDRY GENERATE BILLING REPORT

// REPORT - HIST. PESOS
export function getLaundryBillingReportPDF(dto: LaundryFilterReportModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryBillingReportPDF`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryBillingReportXLS(dto: LaundryFilterReportModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryBillingReportExcel`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryBillingReportCSV(dto: LaundryFilterReportModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryBillingReportCSV`, dto, {
    responseType: 'arraybuffer',
  })
}

// REPORT - CECO

export function getLaundryCostReportPDF(dto: LaundryFilterReportModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryCompanyCenterCostReportPDF`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryCostReportXLS(dto: LaundryFilterReportModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryCompanyCenterCostReportExcel`, dto, {
    responseType: 'arraybuffer',
  })
}

export function getLaundryCostReportCSV(dto: LaundryFilterReportModel) {
  return axios.post<any>(`${BASEURL}/order/getLaundryCompanyCenterCostReportCSV`, dto, {
    responseType: 'arraybuffer',
  })
}
// GENERATE REPORT - SAVE REPORT
export function saveLaundryGenerateBilling(dto: LaundryFilterReportModel) {
  return axios.post<ResponseObjectPaginated<LaundryBillingModel[]>>(
    `${BASEURL}/report/saveLaundryBillingReport`,
    dto,
  )
}

// TABLE - CECO
export function getLaundryCost(dto: LaundryFilterReportModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryCostModel[]>>(
    `${BASEURL}/order/getLaundryCompanyCenterCostReportDto/${page}`,
    dto,
  )
}

// TABLE - HIST. PESOS
export function getLaundryBilling(dto: LaundryFilterReportModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBillingModel[]>>(
    `${BASEURL}/order/getLaundryBillingReport/${page}`,
    dto,
  )
}

// ----------------------  VIEW LAUNDRY BILLING REPORT

// TABLE
export function getLaundryGenerateBilling(dto: LaundryFilterReportModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBillingModel[]>>(
    `${BASEURL}/report/getAllLaundryBillingReport/${page}`,
    dto,
  )
}

// TABS - TABLE - HIST. PESOS

export function getLaundryGenerateBillingById(id: any, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBillingModel[]>>(
    `${BASEURL}/report/getLaundryBillingReport/${page}?id=${id}`,
    {},
  )
}

// TABS - REPORT - HIST. PESOS

export function getLaundryGenerateBillingReportPDF(id: any) {
  return axios.post<any>(
    `${BASEURL}/report/getLaundryBillingReportPDF?id=${id}`,
    {},
    {
      responseType: 'arraybuffer',
    },
  )
}

export function getLaundryGenerateBillingReportXLS(id: any) {
  return axios.post<any>(
    `${BASEURL}/report/getLaundryBillingReportExcel?id=${id}`,
    {},
    {
      responseType: 'arraybuffer',
    },
  )
}

export function getLaundryGenerateBillingReportCSV(id: any) {
  return axios.post<any>(
    `${BASEURL}/report/getLaundryBillingReportCSV?id=${id}`,
    {},
    {
      responseType: 'arraybuffer',
    },
  )
}

// TABS - TABLE - CECO

export function getLaundryCostDetailById(id: any, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryBillingModel[]>>(
    `${BASEURL}/report/getLaundryCompanyCenterCostReport/${page}?id=${id}`,
    {},
  )
}

// TABS - REPORT - CECO

export function getLaundryCostDetailReportPDF(id: any) {
  return axios.post<any>(
    `${BASEURL}/report/getLaundryCompanyCenterCostReportPDF?id=${id}`,
    {},
    {
      responseType: 'arraybuffer',
    },
  )
}

export function getLaundryCostDetailReportXLS(id: any) {
  return axios.post<any>(
    `${BASEURL}/report/getLaundryCompanyCenterCostReportExcel?id=${id}`,
    {},
    {
      responseType: 'arraybuffer',
    },
  )
}

export function getLaundryCostDetailReportCSV(id: any) {
  return axios.post<any>(
    `${BASEURL}/report/getLaundryCompanyCenterCostReportCSV?id=${id}`,
    {},
    {
      responseType: 'arraybuffer',
    },
  )
}

// REPORTE FACTURACIÓN DE SERVICIOS DE LAVANDERÍA
// TABLE
export function getLaundryServicesBillingReport(
  dto: LaundryFilterReportLaundry2Model,
  page: number,
) {
  return axios.post<ResponseObjectPaginated<LaundryBillingModel[]>>(
    `${BASEURL}/report/getLaundryServicesBillingReport/${page}/10`,
    dto,
  )
}

export function getLaundryBilling2ReportXLS(dto: LaundryFilterReportLaundry2Model) {
  return axios.post<any>(`${BASEURL}/report/getLaundryServicesBillingReportExcel`, dto, {
    responseType: 'arraybuffer',
  })
}
